import * as React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import TextInput from 'components/TextInput/TextInput';
import StringWidget from 'components/StringWidget/StringWidget';
import Loader from 'components/Common/Loader/Loader';
import Button from 'components/Button/Button';
import { makeLoginRequest } from 'actions/LoginSignupActions/loginActions';
import { getSignupStatus } from 'actions/LoginSignupActions/signupActions';
import { generateLoginOtp } from 'actions/LoginSignupActions/generateLoginOtpActions';
import get from 'lodash/get';
import { isValidMobileNumber, isDigitsOnly, isValidEmail, DIGITS_REGEXP } from 'utils/validators';
import { LOGIN_URL, ACCOUNT_NOT_FOUND_STATE, ACCOUNT_GUEST_STATE } from 'constants/LoginConstants';
import { safeTrim } from 'utils/stringUtils';
import { getOmnitureLoginId } from '../LoginSignupAnalytics';
import { Link } from 'react-router';
import { withToast } from 'components/Toast/Toast';
import { showModal } from 'actions/modalActions';
import { handleLoginAction } from 'utils/LoginUtils/smartLoginHelper';
import { LoginViews } from '../LoginTypes';
import { LOGIN_CHECKOUT_VIEW, LOGIN_PAGE_VIEW } from 'constants/LoginConstants';
import toastConfig from 'toasts.json';
export class SignUpView extends React.Component {
    constructor(props) {
        super(props);
        this.generateOTP = (extraParams) => {
            const { mobileNumber } = this.state;
            const { handleAPIRequest, handleAPIError, changeViewHandler, toast } = this.props;
            const loginId = isValidMobileNumber(mobileNumber) ? `+91${mobileNumber}` : mobileNumber;
            handleAPIRequest(generateLoginOtp, `loginId=${loginId}`, payload => {
                toast.show(toastConfig.verificationCodeSentMsg, { userName: mobileNumber });
                changeViewHandler({
                    view: LoginViews.VERIFICATION,
                    extra: Object.assign({ userName: mobileNumber, payload }, extraParams)
                });
            }, handleAPIError, 'new_otp_sent');
        };
        this.handleSubmit = (e) => {
            e && e.preventDefault();
            const { mobileNumber, extra } = this.state;
            const { handleAPIRequest, handleAPIError, changeViewHandler, compactView, trackOmniture, pageType, loginSource } = this.props;
            if (this.validateAllFields()) {
                const validNumber = isValidMobileNumber(mobileNumber);
                const loginId = validNumber ? `+91${mobileNumber}` : mobileNumber;
                handleAPIRequest(getSignupStatus, { loginId: [loginId], supportAllStates: true }, payload => {
                    const accountState = get(payload, ['data', 'userDetails', loginId]);
                    if (accountState === ACCOUNT_NOT_FOUND_STATE || accountState === ACCOUNT_GUEST_STATE) {
                        if (compactView && isValidEmail(mobileNumber)) {
                            trackOmniture('email_signup', { pageType, loginSource });
                            changeViewHandler({
                                view: LoginViews.SIGNUP,
                                extra: {
                                    emailId: mobileNumber
                                }
                            });
                        }
                        else {
                            trackOmniture('mobile_signup', { pageType, loginSource });
                            this.generateOTP({ signup: true, emailId: extra.emailId, accountState });
                            trackOmniture('otp_requested', { pageType, loginSource });
                        }
                    }
                    else if (compactView) {
                        trackOmniture('checkout_password_shown', {
                            pageType,
                            loginSource,
                            loginId: getOmnitureLoginId(mobileNumber)
                        });
                        changeViewHandler({
                            view: LoginViews.LOGIN,
                            extra: { userName: mobileNumber }
                        });
                    }
                    else {
                        trackOmniture('user_registered', { pageType, loginSource });
                        // When the user is already registered, move them to login flow with entered fields.
                        changeViewHandler({
                            view: LoginViews.LOGIN,
                            extra: { userName: mobileNumber }
                        });
                        handleAPIError('loginRegisteredUserMsg');
                    }
                }, payload => {
                    return handleAPIError(payload, 'signup_failed');
                }, 'signup_btn_clicked');
            }
            else {
                trackOmniture('invalid_email_mobile', { pageType, loginSource, loginId: getOmnitureLoginId(mobileNumber) });
            }
            return false;
        };
        this.handleTextChange = (mobileNumber) => {
            const { compactView, extra } = this.props;
            const value = !extra.emailId && compactView ? mobileNumber : mobileNumber.replace(DIGITS_REGEXP, '');
            this.setState({ mobileNumber: safeTrim(value), invalidMobileNumber: '' });
            return value;
        };
        this.handleClick = (e) => {
            const { viewType, changeViewHandler } = this.props;
            viewType !== LOGIN_PAGE_VIEW &&
                changeViewHandler({
                    view: LoginViews.LOGIN,
                    extra: {
                        userName: this.state.mobileNumber
                    }
                }, e);
        };
        this.validateAllFields = () => {
            const { mobileNumber } = this.state;
            const { compactView, extra } = this.props;
            if (compactView && !extra.emailId) {
                const validInput = isDigitsOnly(mobileNumber)
                    ? isValidMobileNumber(mobileNumber)
                    : isValidEmail(mobileNumber);
                !validInput &&
                    this.setState({
                        invalidMobileNumber: <StringWidget strKey="loginInvalidUserName"/>
                    });
                return validInput;
            }
            else if (!isValidMobileNumber(mobileNumber)) {
                this.setState({
                    invalidMobileNumber: <StringWidget strKey="loginInvalidMobileNumber"/>
                });
                return false;
            }
            return true;
        };
        this.handleOnFocus = () => {
            const { showModal, toast, makeLoginRequest, compactView, viewType, handleLoginSuccess, pageType } = this.props;
            /* Make smartlogin call only when
             * it is checkout page.
             * and on its initial focus (when count is 0).
             * */
            if (this.count === 0 && compactView && pageType === LOGIN_CHECKOUT_VIEW) {
                const loginPayload = {
                    showModal,
                    toast,
                    makeLoginRequest,
                    omnitureData: { source: 'checkout', page: 'checkout' },
                    view: viewType,
                    handleLoginSuccess
                };
                handleLoginAction(loginPayload);
                this.count++;
            }
        };
        this.handleEmailIdChange = (e) => {
            e && e.preventDefault();
            const { changeViewHandler } = this.props;
            changeViewHandler({
                view: LoginViews.SIGNUP,
                extra: {}
            });
        };
        this.state = {
            mobileNumber: get(props, 'extra.mobileNumber', ''),
            extra: props.extra
        };
        this.count = 0;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            mobileNumber: get(nextProps, 'extra.mobileNumber', ''),
            extra: nextProps.extra || {},
            invalidMobileNumber: ''
        });
    }
    render() {
        const { invalidMobileNumber, mobileNumber, extra } = this.state;
        const emailId = get(extra, ['emailId']);
        const { styles, compactView } = this.props;
        const validMobileNo = compactView && !emailId ? isValidMobileNumber(mobileNumber) : !!mobileNumber;
        const inputPlaceholderStr = compactView && !emailId ? 'loginPlaceHolderUserName' : 'loginPlaceHolderMobile';
        return (<form onSubmit={this.handleSubmit} data-aid="LoginSignup-Form">
				{emailId && (<div>
						<TextInput value={emailId} readOnly appendInfo className={styles['form-input']} wrapperClass={styles['form-input-wrap']}>
							<a href="javascript:void(0);" className={cx(styles['append-txt'], styles['input-action-txt'])} onClick={this.handleEmailIdChange} tabIndex={-1}>
								<StringWidget strKey="loginChangeUserNameTxt"/>
							</a>
						</TextInput>
					</div>)}
				<TextInput maxLength={compactView && !emailId ? 'auto' : 10} value={mobileNumber} captureAutoFill prependInfo={validMobileNo} errorMsg={invalidMobileNumber} autoFocus={!compactView} tabIndex="1" onFocus={this.handleOnFocus} placeholder={<StringWidget strKey={inputPlaceholderStr}/>} onTextChange={this.handleTextChange} className={styles['form-input']} wrapperClass={styles['form-input-wrap']}>
					{validMobileNo ? <span className={styles['prepend-txt']}>+91</span> : null}
				</TextInput>
				<div className={styles['terms-text']}>
					By continuing, you agree to Flipkart's{' '}
					<Link to={'/pages/terms'} className={styles['terms-color']} target={'_blank'}>
						Terms of Use
					</Link>{' '}
					and{' '}
					<Link to={'/pages/privacypolicy'} className={styles['terms-color']} target={'_blank'}>
						Privacy Policy
					</Link>
					.
				</div>
				<div className={styles['form-btn-wrap']}>
					<Button type="submit" secondary className={styles['submit-btn']}>
						<Loader stroke="#fff" className={styles['loader-icon']}/>
						<StringWidget strKey="continueText"/>
					</Button>
					{!compactView && (<Button href={LOGIN_URL} className={cx(styles['submit-btn'], styles['white-btn'], styles['change-view-btn'])} onClick={this.handleClick}>
							<StringWidget strKey="loginAlreadyHaveAccountBtnMsg"/>
						</Button>)}
				</div>
			</form>);
    }
}
SignUpView.defaultProps = {
    extra: {},
    trackOmniture: () => null
};
const mapDispatchToProps = {
    showModal,
    makeLoginRequest
};
export default connect(null, mapDispatchToProps)(withToast(SignUpView));
